import moment from 'moment';

const REGEX_VALID_INPUT = /^(\d{0,8})$/;
const REGEX_FORMAT_REPLACE_1 = /(\d{5})/;
const REGEX_FORMAT_REPLACE_2 = /(\d{3})/;
const REGEX_BACKSLASH_REPLACE = /\//g;
const REGEX_VALID_DATE = /^(\d{8})$/;

const REGEX_FORMAT_REPLACER_1 = (m, s1, s2) => s2 || ( s1.slice(0, 4) + '/' + s1[4] );
const REGEX_FORMAT_REPLACER_2 = (m, s1, s2) => s2 || ( s1.slice(0, 2) + '/' + s1[2] );

export class DateFormatter {

    // Example: 05032 -> true
    // Example: 050320 -> true
    // Example: 13121998 -> true
    static isValidInput = (date) => {
        return date.length > 0
            ? REGEX_VALID_INPUT.test(date)
            : true;
    };

    // Example: 1 -> 1
    // Example: 13 -> 13
    // Example: 131 -> 13/1
    // Example: 1312 -> 13/12
    // Example: 13121998 -> 13/12/1998
    static format = (date) => {
        return date
            .replace(REGEX_FORMAT_REPLACE_1, REGEX_FORMAT_REPLACER_1)
            .replace(REGEX_FORMAT_REPLACE_2, REGEX_FORMAT_REPLACER_2);
    };

    // Example: 1 -> 1
    // Example: 13/ -> 13
    // Example: 13/1 -> 131
    // Example: 13/12/ -> 1312
    // Example: 13/12/1998 -> 13121998
    static deformat = (date) => {
        return date
            .replace(REGEX_BACKSLASH_REPLACE, '');
    };

    // Example: 1312199 -> false
    // Example: 131a1998 -> false
    // Example: 13401998 -> false
    // Example: 40121998 -> false
    // Example: 13121998 -> true
    static isValid = (date) => {
        const isEightDigits = REGEX_VALID_DATE.test(date);
        if ( !isEightDigits ) return false;
        const dateFormatted = DateFormatter.format(date);
        const dateMoment = moment(dateFormatted, 'DD/MM/YYYY');
        return !( dateMoment.toString() === 'Invalid date' );
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/formatters/DateFormatter.js